import { KedeDebtStatusEnum } from "../../enums/statusEnums";

const getFieldValue = (field, value) => {
  return value !== null ? value : "-";
};

export const problematicDeptCertificatesColumns = [
  { field: "id", headerName: "ID Βεβαίωσης", width: 100 },
  { field: "m06_id", headerName: "ID Συνδρομής", width: 100 },
  { field: "afm", headerName: "ΑΦΜ Οφειλέτη", width: 100 },
  { field: "fiscal_year", headerName: "Έτος Οφειλής", width: 80 },
  { field: "chamber", headerName: "Eπιμελητηρίο", width: 300 },
  { field: "amount", headerName: "Ποσό Βεβαίωσης", width: 100 },
  {
    field: "status",
    headerName: "Κατάσταση",
    width: 200,
    valueFormatter: (params) => KedeDebtStatusEnum[params.value] || "-",
  },
  {
    field: "errorDesc",
    headerName: "Κωδικός Σφάλματος",
    width: 230,
    valueFormatter: (params) => {
      return getFieldValue(params.field, params.value);
    },
  },
  { field: "date_created", headerName: "Ημερομηνία Δημιουργίας", width: 120 },
  { field: "last_updated", headerName: "Ημερομηνία Ανανέωσης", width: 120 },
];

export const terminalErrorsColumns = [
  { field: "id", headerName: "ID Βεβαίωσης", width: 100 },
  { field: "m06_id", headerName: "ID Συνδρομής", width: 100 },
  { field: "afm", headerName: "ΑΦΜ Οφειλέτη", width: 100 },
  { field: "fiscal_year", headerName: "Έτος Οφειλής", width: 80 },
  { field: "chamber", headerName: "Eπιμελητηρίο", width: 300 },
  { field: "amount", headerName: "Ποσό Βεβαίωσης", width: 100 },
  {
    field: "status",
    headerName: "Κατάσταση",
    width: 200,
    valueFormatter: (params) => KedeDebtStatusEnum[params.value] || "-",
  },
  {
    field: "errorDesc",
    headerName: "Κωδικός Σφάλματος",
    width: 230,
    valueFormatter: (params) => {
      return getFieldValue(params.field, params.value);
    },
  },
  { field: "date_created", headerName: "Ημερομηνία Δημιουργίας", width: 120 },
  { field: "last_updated", headerName: "Ημερομηνία Ανανέωσης", width: 120 },
];

export const deptCertificatesColumns = [
  { field: "id", headerName: "ID Βεβαίωσης", width: 100 },
  { field: "m06_id", headerName: "ID Συνδρομής", width: 100 },
  { field: "afm", headerName: "ΑΦΜ Οφειλέτη", width: 100 },
  { field: "fiscal_year", headerName: "Έτος Οφειλής", width: 80 },
  { field: "chamber", headerName: "Eπιμελητηρίο", width: 300 },
  { field: "amount", headerName: "Ποσό Βεβαίωσης", width: 100 },
  {
    field: "status",
    headerName: "Κατάσταση",
    width: 200,
    valueFormatter: (params) => KedeDebtStatusEnum[params.value] || "-",
  },
  {
    field: "errorDesc",
    headerName: "Κωδικός Σφάλματος",
    width: 230,
    valueFormatter: (params) => {
      return getFieldValue(params.field, params.value);
    },
  },
  { field: "date_created", headerName: "Ημερομηνία Δημιουργίας", width: 120 },
  { field: "last_updated", headerName: "Ημερομηνία Ανανέωσης", width: 120 },
];
